import React from 'react';
import classNames from 'classnames';

import css from './Accordion.module.css'; // Optional: for styling the accordion
import IconChevronDown from '../IconChevronDown/IconChevronDown';

const AccordionPanel = ({
  className,
  iconClassName,
  contentClassName,
  labelClassName,
  headingClassName,
  label,
  content,
  activeTab,
  id,
  activateTab,
}) => {
  const isActive = Array.isArray(activeTab) ? activeTab.includes(id) : activeTab === id;

  if (!content && label) {
    return (
      <h3 id={id} className={classNames(css.heading, headingClassName)} key={1}>
        <span>{label}</span>
      </h3>
    );
  }

  return (
    <div
      id={id}
      className={classNames(css.panel, className)}
      role="tabpanel"
      aria-expanded={isActive}
      key={1}
    >
      <button
        className={classNames(css.panelLabel, labelClassName)}
        role="tab"
        type="button"
        onClick={activateTab}
      >
        <span>{label}</span>
        {!!content && (
          <div className={classNames(css.panelIcon, iconClassName)}>
            <IconChevronDown className={classNames(css.panelIcon, iconClassName)} />
          </div>
        )}
      </button>
      {!!content && (
        <div className={css.panelInner} data-show={isActive} aria-hidden={!isActive}>
          <div className={classNames(css.panelContent, contentClassName)}>{content}</div>
        </div>
      )}
    </div>
  );
};

export default AccordionPanel;
